var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.717,
    height: 11.624,
    viewBox: "0 0 17.717 11.624",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_661",
    "data-name": "Group 661",
    transform: "translate(0.341 0.341)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_600",
    "data-name": "Group 600",
    transform: "translate(0.159 0.159)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11780",
    "data-name": "Path 11780",
    d: "M16.12,11.354H2.059A1.328,1.328,0,0,1,.731,10.026V2.221A1.491,1.491,0,0,1,2.222.73H15.957a1.491,1.491,0,0,1,1.491,1.491v7.806A1.328,1.328,0,0,1,16.12,11.354Z",
    transform: "translate(-0.731 -0.73)",
    fill: "none",
    stroke: "#fc8a06",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11781",
    "data-name": "Path 11781",
    d: "M20.838,5.02l-6.527,6.288a1.992,1.992,0,0,1-2.764,0l-6.54-6.3",
    transform: "translate(-4.57 -4.57)",
    fill: "none",
    stroke: "#fc8a06",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_33",
    "data-name": "Line 33",
    y1: 5.01,
    x2: 5.01,
    transform: "translate(0.413 5.201)",
    fill: "none",
    stroke: "#fc8a06",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_34",
    "data-name": "Line 34",
    x1: 4.953,
    y1: 4.953,
    transform: "translate(11.351 5.259)",
    fill: "none",
    stroke: "#fc8a06",
    strokeLinecap: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/sendIcon.75aad0626eaa91ac605fc4117699f918.svg";
export { ForwardRef as ReactComponent };